import React from 'react';
export type AddressProps = {
  additionalInformation1?: string;
  additionalInformation2?: string;
  addOn?: string;
  className?: string;
  country?: string;
  city?: string;
  displayAddOnFirst?: boolean;
  town?: string;
  stateOrDistrict?: string;
  streetNumber?: string;
  streetName?: string;
  zipCode?: string;
};

function toLine(...values) {
  return values.filter(Boolean).join(' ');
}

function AddressLine({ children }) {
  return children ? <li className="text-14 leading-normal text-black">{children}</li> : null;
}

export const Address = ({
  additionalInformation1,
  additionalInformation2,
  addOn,
  city,
  className,
  country,
  displayAddOnFirst = false,
  stateOrDistrict,
  streetNumber,
  streetName,
  town,
  zipCode,
}: AddressProps) => (
  <ul className={className}>
    {displayAddOnFirst && <AddressLine>{toLine(addOn)}</AddressLine>}
    <AddressLine>{toLine(streetNumber, streetName)}</AddressLine>
    <AddressLine>{toLine(additionalInformation1)}</AddressLine>
    <AddressLine>{toLine(additionalInformation2)}</AddressLine>
    {displayAddOnFirst ? (
      <AddressLine>{toLine(city)}</AddressLine>
    ) : (
      <AddressLine>{toLine(addOn, city)}</AddressLine>
    )}
    <AddressLine>{toLine(town, zipCode)}</AddressLine>
    <AddressLine>{toLine(stateOrDistrict, country)}</AddressLine>
  </ul>
);
